module.exports = __webpack_public_path__ + "static/HKGrotesk-MediumItalic-002c67e7b5ecf8e40bd596a8e74fb846.ttf";